export var IGNORABLE_ERROR_PATTERNS = [
    'Не удалось завершить операцию. Программа вызвала разрыв подключения',
    'A server with the specified hostname could not be found',
    'The Internet connection appears to be offline',
    'Failed to fetch',
    'NetworkError when attempting to fetch resource',
    'The network connection was lost',
    'The operation couldn’t be completed. Software caused connection abort',
    'The operation was aborted',
    "Object doesn't support property or method 'removeAttribute'",
    'HierarchyRequestError',
    'cancelled',
    'too much recursion',
    'ResizeObserver',
    "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node",
    'The play() request was interrupted by a call to pause',
    '_fs',
];
export var LOGGER_NAME = 'datadog';
export var GENERIC_CONTEXT = 'shell';
//# sourceMappingURL=constants.js.map